// // let api = "https://ipadown.lsmwl.com/index.php/index";
// let api = "https://downapi.lmffw.com/index.php/index";
// let host = document.domain;
// console.log(host);
// if (host.indexOf("lumaf") == -1 && host.indexOf("localhost") == -1) {
//   // api = "https://api." + host + "/index";
// }

// export default {
//   appInfo: api + "/Appinfo/info",
//   appinfo_210316: api + "/Appinfo/info_210316",
//   app_check: api + "/Index/testApi",
//   report: api + "/Appinfo/report",
// };

// import axios from 'axios'
// let api = "https://app.36dm.cn/api";
// let api = "https://dev.lumayun.com";

// export default {
//   appInfo: api + "/downapi/index/appInfo2",
//   // appinfo_210316: api + "/Appinfo/info_210316",
//   // app_check: api + "/Index/testApi",
//   report: api + "/index/report",
//   mobileprovision: api + "/uploads/res/app.mobileprovision",
// };

export default {
  appInfo: "/downapi/index/appInfo2",
  // appinfo_210316: api + "/Appinfo/info_210316",
  // app_check: api + "/Index/testApi",
  report: "/index/report",
  mobileprovision: "/uploads/res/app.mobileprovision",
};



// WEBPACK FOOTER //
// ./src/utils/APIUtils.js